var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LLFileModalVideo"},[(_vm.src)?_c('video',{staticClass:"LLFileModalVideo__video",attrs:{"playsinline":"","draggable":"false","src":_vm.src,"poster":_vm.poster,"controls":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }